<template>
    <transition name="modal-fade">
        <div class="modal-overlay">
            <div class="modal-content hide-scrollbar" @click.stop>
                <div style="text-align:right; margin:8px -16px -40px 0; z-index:999;"><span class="material-icons" @click="$emit('close-modal')">close</span></div>

                <div class="col-12 title text-center" style="margin-top:8px;">List of Sub-Contractors</div>

                <div class="col-12 subcontractor-box" style="padding:10px" v-for="obj in Subcontractors" v-bind:key="obj">
                    <div style="display: flex; flex-wrap: wrap;">
                        <div style="flex:1;">
                            <div class="name purple-box" v-if="obj.Name">{{obj.Name}} </div>
                            <div class="info">{{obj.ContactFirstName}} {{obj.ContactLastName}} <span class="date">{{obj.CreatedDate}} </span></div>

                            <div class="border" style="display:flex; width:fit-content; margin-left:16px; vertical-align:top; padding: 4px; margin:8px 0px; gap:10px;" v-if="IsOwner && obj.Phone && obj.Phone.length > 0 && obj.Email && obj.Email.length > 0 ">

                                <a v-if="obj.Phone && obj.Phone.length > 0" :href="'tel:' + obj.Phone" class="btn-call"></a>
                                <a v-if="obj.Email && obj.Email.length > 0" :href="'mailto:' + obj.Email" class="btn-email"></a>
                            </div>
                        </div>

                        <n-dropdown :options="menuOptionsForItem(obj)" trigger="click" @select="handleSelect" style="width:fit-content; border-radius:10px;" v-if="IsOwner" placement="bottom-end" :render-label="renderDropdownLabel">

                            <div class="purple-button">
                                Manage <br />Sub-Contractor <i class="icon-dropdown"></i>
                            </div>


                        </n-dropdown>

                        <div style="display:flex; height:fit-content; display:none;" class="border" v-if="IsOwner">

                            <div class="btn-container" @click="sendSubcontractor(ProjectId, obj.Id)">
                                <div class="btn-new"></div>
                                <div class="small-text">Make a Contract<br />to this <br />Sub-Contractor</div>
                            </div>

                            <div class="btn-container" @click="editSubcontractor(obj, ProjectId)">
                                <div class="btn-edit"></div>
                                <div class="small-text">Edit<br />Sub-Contractor<br />Profile</div>
                            </div>
                            <div class="btn-container" v-if=" (obj.Contracts == null || obj.Contracts.length == 0)" @click="delSubcontractor(obj.Id)">
                                <div class="btn-delete"></div>
                                <div class="small-text">Delete this<br />Sub-Contractor</div>
                            </div>

                            <div class="btn-container" v-else @click="delSubcontractor(obj.Id)" style="opacity: .3;">
                                <div class="btn-delete"></div>
                                <div class="small-text">Delete this<br />Sub-Contractor</div>
                            </div>

                        </div>

                        <div style="display:flex; height:fit-content; opacity:.3;" class="border" v-else>

                            <div class="btn-container">
                                <div class="btn-new"></div>
                                <div class="small-text">Make a Contract<br />to this <br />Sub-Contractor</div>
                            </div>

                            <div class="btn-container">
                                <div class="btn-edit"></div>
                                <div class="small-text">Edit<br />Sub-Contractor<br />Profile</div>
                            </div>
                            <div class="btn-container" v-if=" (obj.Contracts == null)">
                                <div class="btn-delete"></div>
                                <div class="small-text">Delete this<br />Sub-Contractor</div>
                            </div>

                        </div>
                    </div>

                    <div>
                        <div v-for="(contract) in getLatestAmendedList(obj)" class="contract-box" v-bind:key="contract" :class="contract.Status == 'Draft'? 'draft-box':''">

                            <div style="flex: 1">

                                <div v-if="contract.OriginalId == null">
                                    <div v-if="contract.Status == 'Draft'" class="file-name white-box" @click="editContract(ProjectId, obj.Id, getLatestAmendedData(obj, contract).Id, getLatestAmendedData(obj, contract).Data, getLatestAmendedData(obj, contract).Token)">
                                        {{getContractName(contract)}}
                                    </div>
                                    <div v-else-if="contract.Status == 'Signed'" class="file-name white-box" @click="openContract(contract.SignedPdf)">
                                        {{getContractName(contract)}}
                                    </div>
                                    <div v-else class="file-name white-box" @click="openContract(contract.OrignalPdf)">
                                        {{getContractName(contract)}}
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-if="contract.Status == 'Draft'" class="file-name white-box" @click="editContract(ProjectId, obj.Id, getLatestAmendedData(obj, contract).Id, getLatestAmendedData(obj, contract).Data, getLatestAmendedData(obj, contract).Token)">
                                        {{getContractName(contract)}}
                                    </div>
                                    <div v-else-if="contract.Status == 'Signed'" class="file-name white-box" @click="openContract(contract.SignedPdf)">
                                        Amended Agreement - {{getContractName(contract)}}

                                    </div>
                                    <div v-else class="file-name white-box" @click="openContract(contract.OrignalPdf)">
                                        Amended Agreement - {{getContractName(contract)}}

                                    </div>
                                    <n-dropdown :options="menuOptionsForOriginalContracts(obj, contract)" trigger="click" @select="handleSelectForOriginalContracts" style="width:fit-content; border-radius:10px;" placement="bottom-end">

                                        <span style="color:green; font-size:10px; cursor:pointer;">Original Contracts</span>

                                    </n-dropdown>

                                </div>

                                <!--
                                    <solt v-if="getLatestAmendedData(obj, contract).Status == 'Signed'">
                                        <div class="signed-box" @click="openContract(getLatestAmendedData(obj,contract).SignedPdf)"><i class="material-icons">check_circle_outline</i> Signed - {{getLatestAmendedData(contract).CreatedDate}}</div>
                                    </solt>
                                    <solt v-else>
                                        <slot v-for="party in getLatestAmendedData(obj, contract).Parties.filter(x=> x.Type != 0)" v-bind:key="party">
                                            <div class="signed-box" v-if="party.SignedTime !== null"><i class="material-icons">check_circle_outline</i> {{party.BusinessName.substring(0, 10) + "..."}} Signed</div>
                                            <div class="unsigned-box" v-if="party.SignedTime === null && IsOwner" @click="openSignContract(getLatestAmendedData(obj, contract))"><i class="material-icons">radio_button_unchecked</i> {{party.BusinessName.substring(0, 10) + "..."}} Unsigned</div>
                                            <div class="unsigned-box" v-if="party.SignedTime === null && !IsOwner" @click="openUrl(getLatestAmendedData(obj, contract).SignatureUrl)"><i class="material-icons">radio_button_unchecked</i> Sign Now</div>
                                        </slot>
                                    </solt>
                                -->
                                
                                <div class="signed-box" v-if="getLatestAmendedData(obj, contract).Status == 'Signed' " @click="openContract(getLatestAmendedData(obj, contract).SignedPdf)"><span class="material-icons" style="color:darkgreen; font-size:14px;">check_circle_outline</span>Signed - {{getLatestAmendedData(obj, contract).CreatedDate}}</div>
                                <div class="unsigned-box" v-if="getLatestAmendedData(obj, contract).Status != 'Signed' && getLatestAmendedData(obj, contract).Status != 'Draft' && IsOwner" @click="openSignContract(getLatestAmendedData(obj, contract))"> Unsigned</div>
                                <div class="unsigned-box" v-if="getLatestAmendedData(obj, contract).Status != 'Signed' && getLatestAmendedData(obj, contract).Status != 'Draft' && !IsOwner" @click="openUrl(getLatestAmendedData(obj, contract).SignatureUrl)"> Sign Now</div>
     
                            </div>

                            <div style="align-content: center;">
                                
                                <div v-if="contract.Status == 'Draft'"  class="expired-text">Draft Contract</div>
                                <div v-else-if="contract.IsExpired && contract.Status != 'Signed'"  class="expired-text">Contract Expired</div>
                        

                                <n-dropdown :options="menuOptionsForContract(obj, contract)" trigger="click" @select="handleSelectContract" style="width:fit-content; border-radius:10px;" v-if="IsOwner" placement="bottom-end" :render-label="renderDropdownLabel" :disabled="$core.data.UserInfo.Metadata?.IsRestricted">

                                    <div class="purple-button" style="display:inline-block; line-height:24px;">
                                        Edit Contract {{$core.data.UserInfo.Metadata?.IsRestricted?'(Unsubscribed)':''}} <i class="icon-dropdown"></i>
                                    </div>
 
                                </n-dropdown>


                                <div style="display:flex; background-color:white; height:fit-content; display:none;" class="border" v-if="IsOwner">
                                    <div class="btn-container" @click="editContract(ProjectId, obj.Id, getLatestAmendedData(obj, contract).Id, getLatestAmendedData(obj, contract).Data, getLatestAmendedData(obj, contract).Token)">
                                        <div class="btn-edit"></div>
                                        <div class="small-text">Edit<br />Contract</div>
                                    </div>
                                    <div class="btn-container" v-if="contract.Status != 'Signed'" @click="cancelContract(getLatestAmendedData(obj, contract).Id, ProjectName + ' - ' + getLatestAmendedData(obj, contract).CreatedDate )">
                                        <div class="btn-delete"></div>
                                        <div class="small-text">Delete<br />Contract</div>
                                    </div>
                                    <div class="btn-container" v-else style="opacity:.3;">
                                        <div class="btn-delete"></div>
                                        <div class="small-text">Delete<br />Contract</div>
                                    </div>
                                    <div class="btn-container" @click="resendContract(getLatestAmendedData(obj, contract).Id)">
                                        <div class="btn-send"></div>
                                        <div class="small-text">Resend<br />Contract</div>
                                    </div>
                                </div>

                                <div style="display: flex; background-color: white; height: fit-content; opacity: .3; display: none;" class="border" v-else>
                                    <div class="btn-container">
                                        <div class="btn-edit"></div>
                                        <div class="small-text">Edit<br />Contract</div>
                                    </div>
                                    <div class="btn-container">
                                        <div class="btn-delete"></div>
                                        <div class="small-text">Delete<br />Contract</div>
                                    </div>
                                    <div class="btn-container">
                                        <div class="btn-send"></div>
                                        <div class="small-text">Send<br />Contract</div>
                                    </div>
                                </div>

                            </div>

                            

                        </div>
                    </div>


                </div>

            </div>

            <CustomPopup :visible="showPopup"
                         :icon="popupIcon"
                         :iconSrc="popupIconSrc"
                         :iconColor="iconColor"
                         :title="popupTitle"
                         :content="content"
                         :cancelText="cancelText"
                         :confirmText="confirmText"
                         :confirmButtonType="confirmButtonType"
                         :confirmAction="currentConfirmAction"
                         @cancel="onCancel" />

        </div>
    </transition>

</template>

<script>

    import CustomPopup from './CustomPopup.vue';
    import { fileUrl } from '../../composables/http';
    export default {
        components: { CustomPopup},
        data() {
            return {
                Subcontractors: [],
                ProjectId: '',
                ProjectName: "",
                Contract: {},
                UserId: null,
                UserName: null,
                IsOwner: false,
                menuOptions: [{
                    label: "Make a Contract to this Sub-Contractor",
                    key: "makecontract"

                },
                
                {
                    label: "Edit Sub-Contractor Profile",
                    key: "edit"

                },
                {
                    label: "Remove from Project",
                    key: "delete"

                },
                ],

                menuOptionsContract: [{
                    label: "Edit Contract",
                    key: "edit"

                },

                {
                    label: "Resend Contract",
                    key: "resend"

                },
                {
                    label: "Delete Contract",
                    key: "delete"

                },
                ],

                //Custom Popup

                showPopup: false,
                popupIcon: null, // Set to null since we'll use an image
                popupIconSrc: '', // Use this variable to hold the image path
                iconColor: '',
                popupTitle: '',
                content: '',
                cancelText: '',
                confirmText: '',
                confirmButtonType: 'primary',
                currentConfirmAction: null,
            }
        },
        mounted() {
            this.UserId = this.$core.data.UserInfo.Id;
            this.UserName = this.$core.data.UserInfo.UserName;

            if (this.$core.data.UserInfo.Metadata?.IsRestricted) {
                
                var option = this.menuOptions.find(m => m.key == 'makecontract');
                option.label = "Make a Contract to this Sub-Contractor (Unsubscribed)";
                option.disabled = true;

                option = this.menuOptions.find(m => m.key == 'edit');
                option.label = "Edit Sub-Contractor Profile (Unsubscribed)";
                option.disabled = true;
            }

        },
         
        methods: {


            renderDropdownLabel(option) {
                const { key, item } = JSON.parse(option.key);

                //console.log("renderDropdownLabel", key, item);
                //console.log("option", option.label);

                var iconCss = "btn-new";

                switch (key) {
                    case 'makecontract':
                        iconCss = "btn-new";
                        break;
                    case 'addsub':
                        iconCss = "btn-add-sub";
                        break;
                    case 'edit':
                        iconCss = "btn-edit";
                        break;
                    case 'delete':
                        iconCss = "btn-delete";
                        break;
                    case 'movetoarchive':
                        iconCss = "btn-move";
                        break;
                    case 'movetocurrent':
                        iconCss = "btn-move";
                        break;
                    case 'movetopending':
                        iconCss = "btn-move";
                        break;
                    case 'resend':
                        iconCss = "btn-move";
                        break;
                }


                var className ="custom-dropdown-option";

                if (option.label == "Remove from Project" && item.Contracts &&item.Contracts.length > 0) {
                    option.disabled = true;  
                    if(option.label.indexOf("NA") == -1)
                        option.label += " NA";                   
                    className += " disabled";
                }

                if (option.label == "Edit Contract" && !item.IsEditable){
                    option.disabled = true;  
                    if(option.label.indexOf("NA") == -1)
                        option.label += " NA";                   
                    className += " disabled";
                }
                     
                if(option.label == "Resend Contract" && !item.IsResendable){
                    option.disabled = true;  
                    if(option.label.indexOf("Not Available") == -1)
                        option.label += " (Not Available)";
                    className += " disabled";
                }

                if (option.label == "Delete Contract" && !item.IsDeletable) {
                    option.disabled = true;
                    if (option.label.indexOf("NA") == -1)
                        option.label += " NA";
                    className += " disabled";
                }

                return (
                    <div class={className}>
                        {/* Use className instead of class in JSX */}
                        <span class={iconCss}></span>
                        <span class="custom-option-label">{option.label}</span>
                    </div>
                );
            },
            menuOptionsForItem(item) {
                var options = this.menuOptions.map(option => ({
                    ...option,
                    item,  // Add item reference to each option
                    key: JSON.stringify({ key: option.key, item }),
                    
                }));
                 
                return options;
            },
            menuOptionsForContract(sub, contract){
                var options = this.menuOptionsContract.map(option => ({
                    ...option,
                    item: contract,  // Add item reference to each option
                    key: JSON.stringify({ key: option.key, item: contract, sub: sub }),

                }));

                return options;
            },

            menuOptionsForOriginalContracts(sub, contract) {
                let amendedList = [];

                //console.log("menuOptionsForOriginalContracts", contract);

                let previousAmended = this.getOriginalContractData(sub, contract.OriginalId);

                //console.log("menuOptionsForOriginalContracts previousAmended", previousAmended);

                while (previousAmended.length > 0) {
                    amendedList.push(...previousAmended);
                    previousAmended = this.getOriginalContractData(sub, previousAmended[previousAmended.length - 1].OriginalId);
                    //console.log("menuOptionsForOriginalContracts 2222", previousAmended);
                }

                var options = [];
                for (var i = 0; i < amendedList.length; i++) {
                    options.push({ label: this.getContractName(amendedList[i]), key: amendedList[i].OrignalPdf })
                }
                
                return options;
            },

            handleSelectForOriginalContracts(key) {
                //console.log("handleSelectForOriginalContracts", key);

                this.openContract(key);
            },

            handleSelectContract(serializedKey) {

                const { key, item, sub } = JSON.parse(serializedKey);

                //console.log("handleSelectContract", sub);
                console.log("handleSelectContract", item);
                switch (key) {
                    case 'resend':
                        this.resendContract(item.Id);
                        break;

                    case 'edit':
 

                        this.editContract(this.ProjectId, sub.Id, item.Id, item.Data, item.Token);
                        break;
                    case 'delete':

                       
                        this.cancelContract(item.Id, this.ProjectName + ' - ' + item.CreatedDate)
                        break;


                }
            },

            handleSelect(serializedKey) {
                const { key, item } = JSON.parse(serializedKey);
                
                switch (key) {
                    case 'makecontract':
                        this.sendSubcontractor(this.ProjectId, item.Id);
                         
                        break;
                   
                    case 'edit':
                        
                        this.editSubcontractor(item, this.ProjectId);
                        break;
                    case 'delete':
                        
                        this.delSubcontractor(item.Id);
                       
                        break;
                    

                }
            },


            // Get all original data (those with no originalId)
            getOriginalData(sub) {
                if (sub.Contracts && sub.Contracts.length > 0)
                    return sub.Contracts.filter(contract => contract.OriginalId === null);
                else
                    return null;
            },

            // Recursively get all amended data for a specific original
            getAllAmendedData(sub, original) {

                //console.log("getAllAmendedData", original);
                let amendedList = [];
                let nextAmended = this.getAmendedData(sub, original.Id);

                while (nextAmended.length > 0) {
                    amendedList.push(...nextAmended);
                    nextAmended = this.getAmendedData(sub, nextAmended[nextAmended.length - 1].Id);
                }

                return amendedList;
            },

            // Get amended data for a specific original id
            getAmendedData(sub, originalId) {
                return sub.Contracts.filter(contract => contract.OriginalId === originalId);
            },
            getOriginalContractData(sub, originalId) {
                return sub.Contracts.filter(contract => contract.Id === originalId);
            },
            // Get the latest amended data
            getLatestAmendedData(sub, original) {

                //console.log("getLatestAmendedData sub", sub);
                //console.log("getLatestAmendedData original", original);
                if (!original)
                    return null;

                let latestAmended = original;
                let nextAmended = this.getAmendedData(sub, original.Id);

                while (nextAmended.length > 0) {
                    latestAmended = nextAmended[nextAmended.length - 1];
                    nextAmended = this.getAmendedData(sub, latestAmended.Id);
                }

                return latestAmended;
            },

            getLatestAmendedList(sub) {
                // Get all original projects (projects without an originalId)
                //console.log("getLatestAmendedList", sub);

                let originalProjects = this.getOriginalData(sub);

                //console.log("getLatestAmendedList", originalProjects);


                // Map through each original project and get the latest amended data
                var list = [];
                if (originalProjects!=null && originalProjects.length > 0) {
                    list = originalProjects.map(
                        original => this.getLatestAmendedData(sub, original)
                    );
                }
                

                //console.log("getLatestAmendedList", list);

                
                return list;
            },

            getContractName(contract) {
                var name = contract.Data.ScopeOfServices?.length > 30 ? contract.Data.ScopeOfServices.substring(0, 30) + '...' : contract.Data.ScopeOfServices;
                name += " " + contract.CreatedDate;

                return name;
            },

            dataUpdate(obj, projectId, isOwner) {

                this.Subcontractors = obj;
                this.ProjectId = projectId;
                this.IsOwner = isOwner;

                console.log("Subcontractors", this.Subcontractors);
            },
            editContract(projectid, subcontractorid, contractid, obj, token) {

              
                obj.CommencementDate = obj.CommencementDate.substring(0, 10);
                obj.CompletionDate = obj.CompletionDate.substring(0, 10);

                obj.ProjectId = projectid;
                obj.SubContractorId = subcontractorid;
                obj.Token = token;
                obj.Id = contractid;    

                this.$core.data.SelectedSubContract = obj;
                this.$core.data.DisplayPage = 'Project';
                this.$router.push('/EditSubContract/' + contractid);
            },
            cancelContract(contractId, name) {
                let _this = this;

                this.showPopup = true;


                //this.popupIcon = 'FieldTimeOutlined';
                this.iconColor = 'red';
                this.popupIconSrc = require('@/assets/images/icons/DeleteIcon.png'); // Replace with your image path
                this.popupTitle = "Delete Contract";
                this.content = "Are you sure you want to delete this contract?";
                this.cancelText = 'Cancel';
                this.confirmText = 'Delete';
                this.confirmButtonType = 'error';

                this.currentConfirmAction = () => {
                    
                    this.$http.request("put", `/api/app/contract/cancel?id=${contractId}`).then((res) => {
                        //console.log("res", res);
                       
                        if (res?.Type == 200) {
                            //this.getProjects();
                            _this.$emit('refresh');
                            _this.$emit('close-modal');

                            this.showPopup = true;

                            //this.popupIcon = 'FieldTimeOutlined';
                            this.iconColor = 'red';
                            this.popupIconSrc = null // Replace with your image path
                            this.popupTitle = "Success";
                            this.content = "Contract Deleted!";
                            this.cancelText = null;
                            this.confirmText = 'OK';
                            this.confirmButtonType = 'success';
                            this.currentConfirmAction = null;

                          
                        }
                    });

                };

                 
            },
            resendContract(contractId) {

                let _this = this;

                this.showPopup = true;


                //this.popupIcon = 'FieldTimeOutlined';
                this.iconColor = 'red';
                this.popupIconSrc = require('@/assets/images/icons/ResendIcon.png'); // Replace with your image path
                this.popupTitle = "Resend Contract";
                this.content = "Are you sure you want to send this contract?";
                this.cancelText = 'Cancel';
                this.confirmText = 'Resend';
                this.confirmButtonType = 'success';

                this.currentConfirmAction = () => {

                    this.$loader.show(null, 30);
                    this.$http.request("put", `/api/app/contract/resend?id=${contractId}` ).then((res) => {

                        if (res?.Type == 200) {

                            this.showPopup = true;

                            //this.popupIcon = 'FieldTimeOutlined';
                            this.iconColor = 'red';
                            this.popupIconSrc = null // Replace with your image path
                            this.popupTitle = "Success";
                            this.content = "Contract Resent!";
                            this.cancelText = null;
                            this.confirmText = 'OK';
                            this.confirmButtonType = 'success';
                            this.currentConfirmAction = null;

                         
                        }
                    }).finally(() => {
                        this.$loader.hide();
                    });

                };
            },

            openContract(Id) {
                window.open(fileUrl(Id));
            },
            openUrl(url) {
                window.open(url);
            },
            openSignContract(contract) {

                this.$emit('close-modal');
                this.$emit('uploadSigned', contract);

            },
            IsPartyB(contract) {
                return contract.PartyBId == this.UserId || contract.PartyBEmail == this.UserName;
            },

            sendSubcontractor(projectId, subId) {
                 
                if (this.$core.data.Business.Signature == null || this.$core.data.Business.Signature === undefined || this.$core.data.Business.Signature == '') {
                    this.$alert("Please upload your signature before making a contract.");
                    this.$router.push('/MyProfile/3');

                }
                else {
                    this.$core.data.DisplayPage = 'Project';
                    this.$router.push('/MakeSubContract/' + projectId + "/" + subId);
                }

            },

            editSubcontractor(obj, projectId) {
                 
                var info = {};

                info.Business = obj;
                info.ProjectId = projectId;

                //console.log('editSubContractor', info);
                this.$emit('editSubContractor', info);
                //this.$emit('close-modal');
                 
            },
            delSubcontractor(id) {
 
                let _this = this;

                this.showPopup = true;


                //this.popupIcon = 'FieldTimeOutlined';
                this.iconColor = 'red';
                this.popupIconSrc = require('@/assets/images/icons/DeleteIcon.png'); // Replace with your image path
                this.popupTitle = "Remove Sub-Contractor from this project";
                this.content = "Are you sure you want to remove this Sub-Contractor from this project?";
                this.cancelText = 'Cancel';
                this.confirmText = 'Remove';
                this.confirmButtonType = 'error';

                this.currentConfirmAction = () => {

                    this.$http.request("put", "/api/app/subcontractor/deletefromproject", {subcontractorId: id, projectId: this.ProjectId}).then((res) => {

                        if (res?.Type == 200) {
                            _this.$emit('delSubContractor');
                            
                            this.showPopup = true;

                            //this.popupIcon = 'FieldTimeOutlined';
                            this.iconColor = 'red';
                            this.popupIconSrc = null // Replace with your image path
                            this.popupTitle = "Success";
                            this.content = "Sub-Contractor Removed!";
                            this.cancelText = null;
                            this.confirmText = 'OK';
                            this.confirmButtonType = 'success';
                            this.currentConfirmAction = ()=>{ _this.$emit('close-modal');};

                          
                        }

                    });
                };

            },

            //Custom Popup
            archiveProject() {
                console.log('Project archived');
                this.showPopup = false;
            },
            onCancel() {
                this.showPopup = false;
                this.currentConfirmAction = null;
            },
        }
    }
</script>

<style scoped>

    .contracts-container{flex: 1; width: unset; justify-content: center; align-items:end; margin-right:88px;}

    .purple-button {
        display: flex;
        gap: 4px;
        align-items: center;
        border: 1px solid #ccc;
    }
    .subcontractor-box {
        border: 1px solid #ccc;
        border-radius: 10px;
        padding: 6px;
        margin: 6px 0;
        box-shadow: rgba(0,0,0,.2) 1px 1px;
        -webkit-box-shadow: rgba(0,0,0,.2) 1px 1px;
        
    }

    .subcontractor-box .name{font-weight:600; font-size:14px;}
    .subcontractor-box .info{font-weight:400; font-size:12px;}
    .subcontractor-box .addr{font-weight:400; font-size:12px; color:#ccc;}
    .subcontractor-box .date{font-size: 12px; font-weight:400; color:gray; }

    .contract-box {
        padding: 6px;
        margin: 6px;
        display: flex;
        border-radius: 10px;
        background-color: #f1f2f6;
        flex-wrap: wrap;
    }

    .draft-box {
        background-color: #ff000044 !important;
    }
    
    .border {
        border: 1px solid #ccc !important;
        border-radius: 10px;
    }

    .modal-overlay {
        z-index: 999;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #000000da;
    }

    .modal-content {
        background-color: white;
        height: auto;
        width: 800px;
        max-width: 90vh;
        max-height: 90vh;
        margin-top: 5%;
        padding: 0px 24px;
        border-radius: 20px;
        overflow: auto;
    } 

    .check {
        width: 150px;
    }

   
    p {
        /* font-weight: 500; */
        font-size: 16px;
        margin: 20px 0;
    }

    button {
        background-color: #ac003e;
        width: 150px;
        height: 40px;
        color: white;
        font-size: 14px;
        border-radius: 16px;
        margin-top: 50px;
    }

    .modal-fade-enter,
    .modal-fade-leave-to {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity 0.5s ease;
    }

    .form-check-inline {
        margin: 4px 0px;
    }

    .form-check-label {
        vertical-align: middle;
    }

    .form-check-input {
        vertical-align: middle;
    }
</style>